<template>
  <div>
    <el-button type="primary" @click="handleOpenDialog"
      >附加素材({{ additionalMediaList.length }})</el-button
    >
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%"
      title="附加素材配置"
      top="10px"
      class="config-dialog"
    >
      <template #title>
        <span style="font-size: 20px">附加素材配置</span>
        <span style="color: #999">
          (最少添加{{ adSpaceModel.additionalMediaMinNum }}个，最多{{
            adSpaceModel.additionalMediaMaxNum
          }}个)</span
        >
      </template>
      <el-tabs
        v-model="activeTab"
        class="tabs-in-dialog"
        type="card"
        closable
        :addable="mediaAddable"
        @edit="handleTabsEdit"
      >
        <template v-if="mediaList.length === 0">
          <div class="empty-media" style="padding: 50px 0; text-align: center">
            <i class="el-icon el-icon-picture-outline"></i>
            <span>暂无附加素材，请点击右上角“+”添加</span>
          </div>
        </template>
        <el-tab-pane
          v-for="(item, tabIndex) in mediaList"
          :key="tabIndex"
          :label="'素材' + [tabIndex + 1]"
          :name="tabIndex + ''"
        >
          <AdditionalMediaConfigItem
            :adSpaceModel="adSpaceModel"
            :mediaIndex="tabIndex"
            :mediaModel="item"
            :mediaList="mediaList"
          />
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AdditionalMediaConfigItem from './AdditionalMediaConfigItem.vue'
import { genAdditionalMedia, eventEnum } from './MaterialCreative'
import { filterDefaultTips, checkTargetEvent, checkTipsDetail } from './creativeUtil'

export default {
  components: {
    AdditionalMediaConfigItem
  },
  inject: ['adSpaceModel', 'spaceTipsTempId', 'spaceTipsDetail'],
  props: {
    additionalMediaList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      dialogVisible: false,
      activeTab: '0',
      showCreativeCentre: false,
      mediaList: []
    }
  },
  computed: {
    mediaAddable() {
      return this.mediaList.length < this.adSpaceModel.additionalMediaMaxNum
    }
  },
  methods: {
    handleOpenDialog() {
      if (this.additionalMediaList.length > 0) {
        this.mediaList = this.cloneDeep(this.additionalMediaList)
      } else {
        const newMedia = genAdditionalMedia()
        newMedia.tipsTempId = this.spaceTipsTempId
        newMedia.tipsDetail = filterDefaultTips(this.spaceTipsDetail)
        this.mediaList = [newMedia]
      }
      this.activeTab = this.mediaList.length ? '0' : ''
      this.dialogVisible = true
    },
    handleTabsEdit(name, action) {
      const index = parseInt(name)
      if (action === 'add') {
        const mediaModel = genAdditionalMedia()
        mediaModel.tipsTempId = this.spaceTipsTempId
        mediaModel.tipsDetail = filterDefaultTips(this.spaceTipsDetail)
        this.mediaList.push(mediaModel)
        this.activeTab = `${this.mediaList.length - 1}`
      }
      if (action === 'remove') {
        if (this.mediaList[index].mediaId) {
          this.$confirm('此操作将从创意中清除该素材, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            center: true,
            showClose: false
          })
            .then(() => {
              this.mediaList.splice(index, 1)
              this.activeTab = this.mediaList.length ? `${this.mediaList.length - 1}` : ''
            })
            .catch(() => {})
        } else {
          this.mediaList.splice(index, 1)
          this.activeTab = this.mediaList.length ? `${this.mediaList.length - 1}` : ''
        }
      }
    },
    handleSave() {
      if (!this.validateMedia()) return

      this.$emit('change', this.mediaList)
      this.$message.success('保存成功！')
      this.dialogVisible = false
    },
    validateMedia() {
      if (this.mediaList.length < this.adSpaceModel.additionalMediaMinNum) {
        this.$message.error(`最少添加${this.adSpaceModel.additionalMediaMinNum}个素材`)
        return false
      }
      for (let i = 0; i < this.mediaList.length; i++) {
        const media = this.mediaList[i]
        // 校验交互事件
        const targetEvent = media.targetEvent
        const existTargetEvent =
          media.shipType !== 'NONE' && targetEvent.targetTempId > -1
        const isVoiceEvent = media.shipType === 'VOICE' && targetEvent.targetTempId > -1
        // 语音触发校验唤醒词
        if (isVoiceEvent && !targetEvent.voiceWord) {
          this.$message.error(`素材${i + 1}语音触发的唤醒词不能为空!`)
          return false
        }
        // 校验按键、语音、自动事件的扩展参数
        if (existTargetEvent) {
          const eventErr = checkTargetEvent(targetEvent)
          if (eventErr) {
            this.$message.error(
              `素材${i + 1}${eventEnum[media.shipType].name}${eventErr}`
            )
            return false
          }
        }

        // 校验提示语
        if (media.tipsDetail) {
          if (!checkTipsDetail(media.tipsDetail)) {
            this.$message.error(`素材${i + 1}提示语参数校验不完整, 请检查!`)
            return false
          }
        }
      }
      return true
    }
  }
}
</script>

<style lang="stylus" src="./materialOwnSource.styl" scoped></style>
